import angular from 'angular';

angular
  .module('constants', [])
  .constant('topics', {
    nav: {
      allKeys: 'navigation.key',
      up: 'navigation.key.up',
      down: 'navigation.key.down',
      left: 'navigation.key.left',
      right: 'navigation.key.right',
      enter: 'navigation.key.enter'
    },
    state: {
      reactivate: 'state.reactivate',
      inactivate: 'state.inactivate',
      enter: 'state.enter',
      exit: 'state.exit'
    },
    component: {
      selectPhotos: 'select.photos',
      slideshowToggle: 'slideshow.toggle',
      enlargedSlideshow: 'enlarged.slideshow'
    },
    regions: {
      select: 'regions.select'
    },
    headerMain: {
      selectTab: 'headerMain.selectTab',
      selectSection: 'headerMain.selectSection',
      menuReady: 'headerMain.menuReady',
      resetSubnav: 'headerMain.resetSubnav'
    },
    auth: {
      unauthenticated: 'auth.unauthenticated',
      unauthorized: 'auth.unauthorized',
      failed: 'auth.failed'
    },
    remoteKeys: {
      allKeys: 'remote.key',
      play: 'remote.key.play',
      pause: 'remote.key.pause',
      forward: 'remote.key.forward',
      rewind: 'remote.key.rewind',
      back: 'remote.key.back'
    },
    playerStates: {
      name: 'playerStates',
      play: {
        name: 'play',
        scrubSpeed: 1
      },
      pause: {
        name: 'pause',
        scrubSpeed: 0
      },
      rewind: {
        name: 'rewind',
        scrubSpeed: -2
      },
      forward: {
        name: 'forward',
        scrubSpeed: 2
      },
      stop: {
        name: 'stop',
        scrubSpeed: 0
      }
    },
    ads: {
      refreshAd: 'refreshAd'
    }
  })
  .constant('cacheExpiry', {
    default: 5 * 60 * 1000
  })
  .constant('storageKeys', {
    selectedRegion: 'selected-region',
    regions: 'regions',
    profile: 'profile',
    authToken: 'auth_token',
    mockData: 'mock-data',
    jwtToken: 'jwt_token',
    adPlayCount: 'ad-play-count'
  })
  .constant('adProps', {
    home: {
      sectionName: 'home',
      rightBannerLocation: 'right',
      bottomBannerLocation: 'footer_center',
      previousElement: 'adProps.previousElement'
    },
    photos: {
      sectionName: 'photos',
      leftBannerLocation: 'left',
      leftBottomBannerLocation: 'footer_left',
      rightBottomBannerLocation: 'footer_right'
    }
  })
  .constant('states', {
    home: 'app.home.news',
    io_extra: 'app.home.extra',
    in_depth: 'app.home.inDepth',
    features: 'app.home.features',
    enlargedLiveFeed: 'app.enlargedLivefeed',
    gallery: 'app.gallery',
    photos: 'app.home.photos',
    weather_center: 'app.home.weatherhome',
    weather: 'app.home.weather',
    traffic_center: 'app.home.traffichome',
    traffic: 'app.home.traffic',
    videoplayer: 'app.videoplayer',
    closingsAndDelays: 'app.home.closingsAndDelays',
    regionSelectionLanding: 'app.regionSelectionLanding'
  })
  .constant('adRotationFrequency', 3)
  .constant('appName', 'News12');



/** WEBPACK FOOTER **
 ** ./client/app/constants.js
 **/